import request from '@/config/axios'
import type { PageParam } from '@/types/common'
import type { PageResult } from '@/api/lawyer'

export interface FirmCustomerVO {
  id?: number
  customerNo?: string
  customerType: string
  name: string
  idType?: string
  idNo?: string
  creditCode?: string
  mobile?: string
  phone?: string
  email?: string
  province?: string
  city?: string
  district?: string
  address?: string
  industry?: string
  contactName?: string
  contactMobile?: string
  source?: string
  category?: string
  tags?: string[]
  memberUserId?: number
  blacklisted?: boolean
  blacklistReason?: string
  remark?: string
  nextFollowTime?: string
  createTime?: string
}

export interface FirmCustomerPageReqVO extends PageParam {
  name?: string
  mobile?: string
  keyword?: string
  customerType?: string
  category?: string
  blacklisted?: boolean
}

export interface FirmCustomerFollowVO {
  id?: number
  customerId: number
  followType?: string
  content: string
  attachmentUrls?: string[]
  followUserId?: number
  followTime?: string
  createTime?: string
}

export interface FirmCustomerCaseBriefVO {
  id: number
  caseNo?: string
  title?: string
  status?: string
  currentStage?: string
  createTime?: string
}

export const FirmCustomerApi = {
  page: async (params: FirmCustomerPageReqVO): Promise<PageResult<FirmCustomerVO>> =>
    request.get({ url: '/lawyer/firm/customer/page', params }),
  get: async (id: number): Promise<FirmCustomerVO> =>
    request.get({ url: '/lawyer/firm/customer/get', params: { id } }),
  create: async (data: FirmCustomerVO): Promise<number> =>
    request.post({ url: '/lawyer/firm/customer/create', data }),
  update: async (data: FirmCustomerVO): Promise<boolean> =>
    request.put({ url: '/lawyer/firm/customer/update', data }),
  blacklist: async (data: { id: number; blacklisted: boolean; reason?: string }): Promise<boolean> =>
    request.put({ url: '/lawyer/firm/customer/blacklist', data }),
  followPage: async (params: PageParam & { customerId: number }): Promise<PageResult<FirmCustomerFollowVO>> =>
    request.get({ url: '/lawyer/firm/customer/follow/page', params }),
  followCreate: async (data: FirmCustomerFollowVO): Promise<number> =>
    request.post({ url: '/lawyer/firm/customer/follow/create', data }),
  bindCase: async (data: { caseId: number; customerId: number }): Promise<boolean> =>
    request.put({ url: '/lawyer/firm/customer/case/bind-customer', data }),
  listCases: async (customerId: number): Promise<FirmCustomerCaseBriefVO[]> =>
    request.get({ url: '/lawyer/firm/customer/case/list', params: { customerId } })
}
